<template>
  <b-card v-show="type" class="paragraph-object">
    <b-form @submit.prevent="createParagraphObject" id="paragraph-object-create">

      <b-row>
        <b-col cols="8">
          <b-form-group
            id="paragraph-object-infographic-group"
            label="Infographic"
            label-for="paragraph-object-infographic"
            v-if="type == 'infographic'"
            class="paragraph-object__field"
          >
            <b-form-file
              id="paragraph-object-infographic"
              v-model="createForm.infographic"
              placeholder="Choose an image or drop it here..."
              ref="chapterObjectImage"
              required
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-form-group
            id="paragraph-object-data-group"
            label="Data"
            label-for="paragraph-object-data"
            v-if="type == 'data'"
            class="paragraph-object__field"
          >
            <b-form-file
              id="paragraph-object-data"
              v-model="createForm.data"
              placeholder="Choose an image or drop it here..."
              ref="chapterObjectImage"
              required
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-form-group
            id="paragraph-object-image-group"
            label="Image"
            label-for="paragraph-object-image"
            v-if="type == 'image'"
            class="paragraph-object__field"
          >
            <b-form-file
              id="paragraph-object-image"
              v-model="createForm.image"
              placeholder="Choose an image or drop it here..."
              ref="chapterObjectImage"
              required
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-row v-if="uploadedFileUrl && (type == 'infographic' || type == 'data' || type == 'image')" class="mb-3">
            <b-col cols="12" sm="6">
              <img :src="uploadedFileUrl" class="img-fluid" />
            </b-col>
          </b-row>

          <b-form-group
            id="paragraph-object-text-group"
            label="Text"
            label-for="paragraph-object-text"
            v-if="type == 'text'"
            class="paragraph-object__field"
          >
            <vue-editor v-model="createForm.text" :editor-toolbar="editorToolbar" />
          </b-form-group>

          <b-form-group
            id="paragraph-object-sowhat-group"
            label="So What"
            label-for="paragraph-object-sowhat"
            v-if="type == 'sowhat'"
            class="paragraph-object__field"
          >
            <vue-editor v-model="createForm.sowhat" :editor-toolbar="editorToolbar" />
          </b-form-group>

        </b-col>
        <b-col cols="4">

          <div class="paragraph-object__tt">

            <b-row class="mb-2">
              <b-col>
                <div class="paragraph-object__tt-title">3G & Targets</div>
              </b-col>
              <b-col cols="auto">
                <button type="button" class="paragraph-object__tt-add" title="Select 3G & Targets" @click="showAddTags('targets')"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </b-col>
            </b-row>
            <div v-if="createForm.targets.length == 0" class="paragraph-object__tt-empty">
              There are no targets, <a @click="showAddTags('targets')">add one</a>
            </div>
            <ul class="paragraph-object__tt-list" v-else>
              <li v-for="target in createForm.targets" :key="target.gandtarget_id">
                <p>{{ target.label_en }}</p>
                <button type="button" @click="removeTarget(target)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>

            <b-row class="mb-2">
              <b-col>
                <div class="paragraph-object__tt-title">Taxonomies</div>
              </b-col>
              <b-col cols="auto">
                <button type="button" class="paragraph-object__tt-add" title="Taxonomies" @click="showAddTags('taxonomies')"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </b-col>
            </b-row>
            <div v-if="createForm.taxonomies.length == 0" class="paragraph-object__tt-empty">
              There are no taxonomies, <a @click="showAddTags('taxonomies')">add one</a>
            </div>
            <ul class="paragraph-object__tt-list" v-else>
              <li v-for="taxonomy in createForm.taxonomies" :key="taxonomy.tax_id">
                <p>{{ taxonomy.label_en }}</p>
                <button type="button" @click="removeTaxonomy(taxonomy)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>


          </div>

        </b-col>
      </b-row>

      <div class="paragraph-object-alert">
        <b-alert
          :variant="alert.type"
          dismissible
          fade
          :show="alert.show"
          @dismissed="alert.show=0"
          @dismiss-count-down="alertCountDownChanged"
        >
          {{ alert.content }}
        </b-alert>
      </div>

      <div class="text-right">
        <b-button type="button" variant="secondary" @click="closeParagraphObjectCreate" class="mr-3">Cancel</b-button>
        <b-button type="submit" variant="primary"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Create</b-button>
      </div>

    </b-form>

    <MonitorTags
      :tagType="selectedTagType"
      @requestAddTag="addTag"
      :modalTagId="modalTagsId"
      :currentTargets="createForm.targets"
      :currentTaxonomies="createForm.taxonomies"
    />

  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import MonitorTags from "@/components/MonitorTags";

import {
  MONITOR_PARAGRAPH_OBJECT_CREATE
} from "@/store/actions.type";

import {
  STATE_MONITORS_RECENT_TARGETS_SET,
  STATE_MONITORS_RECENT_TAXONOMIES_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorParagraphObjectCreate',
  props: ['paragraphObjectType', 'paragraphId'],
  components: {
    VueEditor,
    MonitorTags
  },
  data() {
    return {
      isLoading: false,
      createForm: {
        infographic: null,
        text: '',
        data: null,
        image: null,
        sowhat: '',
        targets: [],
        taxonomies: []
      },
      uploadedFileUrl: null,
      type: null,
      objectType: 'infographic',
      selectedTagType: 'targets',
      modalTagsId: 'bv-modal-add-tags-0',
      editorToolbar: [
        ["bold", "italic", "underline"],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'align': [] }],
        ['blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        ['clean']
      ],
      alert: {
        show: 0,
        type: '',
        content: ''
      },
      disableChange: false
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent", "targets", "taxonomies"])
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    closeParagraphObjectCreate() {
      this.resetForm();
      this.$emit('creationCancelled');
    },
    createParagraphObject() {
      this.isLoading = true;

      if(!this.validateParagraphObjectData()) {
        return
      }

      let paragraphObjectData = new FormData();
      paragraphObjectData.set('archived', false);
      paragraphObjectData.set('deleted', false);
      paragraphObjectData.set('order', '1');
      if(this.type == 'sowhat') {
        paragraphObjectData.set('object_type', 'so_what');
      } else {
        paragraphObjectData.set('object_type', this.type);
      }
      

      if (this.type === 'infographic') {
        paragraphObjectData.set('value_file', this.createForm.infographic);
      } else if (this.type === 'text') {
        paragraphObjectData.set('value_text', this.createForm.text);
      } else if (this.type === 'data') {
        paragraphObjectData.set('value_file', this.createForm.data);
      } else if (this.type === 'image') {
        paragraphObjectData.set('value_file', this.createForm.image);
      } else if (this.type === 'sowhat') {
        paragraphObjectData.set('value_text', this.createForm.sowhat);
      }

      let paragraphObjectTargets = [];
      let i = 0;
      for (i = 0; i < this.createForm.targets.length; i++) {
        paragraphObjectTargets.push(this.createForm.targets[i].gandtarget_id);
      }
      paragraphObjectData.append('gandtargets', JSON.stringify(paragraphObjectTargets));
      let paragraphObjectTaxonomies = [];
      for (i = 0; i < this.createForm.taxonomies.length; i++) {
        paragraphObjectTaxonomies.push(this.createForm.taxonomies[i].tax_id);
      }
      paragraphObjectData.append('taxonomies', JSON.stringify(paragraphObjectTaxonomies));

      let payload = {
        paragraphId: this.paragraphId,
        paragraphObjectData: paragraphObjectData
      }

      this.$store.dispatch(MONITOR_PARAGRAPH_OBJECT_CREATE, payload).then(() => {
        this.$bvToast.toast(`Paragraph object ${this.objectType} has been created successfully`, {
          title: 'Paragraph object created',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.resetForm();
        this.isLoading = false;
        this.$emit('paragraphObjectCreated');
      });
    },
    validateParagraphObjectData() {

      let idGender = null;
      let idGeolocalization = null;
      let idGeneration = null;
      // let idTarget = null;

      for (let i = 0; i < this.targets.length; i++) {
        if(this.targets[i].label == 'GENERE') {
          idGender = this.targets[i].gandtarget_id;
        }
        if(this.targets[i].label == 'GEOLOCALIZZAZIONE') {
          idGeolocalization = this.targets[i].gandtarget_id;
        }
        if(this.targets[i].label == 'GENERAZIONE') {
          idGeneration = this.targets[i].gandtarget_id;
        }
        // if(this.targets[i].label == 'TARGET') {
        //   idTarget = this.targets[i].gandtarget_id;
        // }
      }

      let errorGender = true;
      let errorGeolocalization = true;
      let errorGeneration = true;
      // let errorTarget = null;

      if(this.createForm.targets.length > 0) {
        for (var k = 0; k < this.createForm.targets.length; k++) {
          if(this.createForm.targets[k].lev_1 === idGender) {
            errorGender = false;
          }
          if(this.createForm.targets[k].lev_1 === idGeolocalization) {
            errorGeolocalization = false;
          }
          if(this.createForm.targets[k].lev_1 === idGeneration) {
            errorGeneration = false;
          }
          // if(this.createForm.targets[k].lev_1 === idTarget) {
          //   errorTarget = false;
          // }
        }
      }

      if(errorGender || errorGeolocalization || errorGeneration || this.createForm.taxonomies.length == 0) {
        this.alert.show = 4;
        this.alert.type = 'danger';
        this.alert.content = 'You must select at least one gender, geolocalization, generation and taxonomy';
        this.isLoading = false;
        return false
      } else {
        return true
      }

    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.uploadedFileUrl = URL.createObjectURL(file);
    },
    showAddTags(tagType) {
      this.selectedTagType = tagType;
      this.$bvModal.show(this.modalTagsId)
    },
    addTag(tag) {
      if(this.selectedTagType === 'targets') {
        if (!this.createForm.targets.includes(tag)) {
          this.createForm.targets.push(tag);
          this.$store.commit(STATE_MONITORS_RECENT_TARGETS_SET, tag);
        }
      } else {
        if (!this.createForm.taxonomies.includes(tag)) {
          this.createForm.taxonomies.push(tag);
          this.$store.commit(STATE_MONITORS_RECENT_TAXONOMIES_SET, tag);
        }
      }     
    },
    removeTarget: function(target) {
      var targetIndexToRemove = this.createForm.targets.indexOf(target);
      if (targetIndexToRemove > -1) {
        this.createForm.targets.splice(targetIndexToRemove, 1);
      }
    },
    removeTaxonomy: function(taxonomy) {
      var taxonomyIndexToRemove = this.createForm.taxonomies.indexOf(taxonomy);
      if (taxonomyIndexToRemove > -1) {
        this.createForm.taxonomies.splice(taxonomyIndexToRemove, 1);
      }
    },
    resetForm() {
      this.uploadedFileUrl = null;
      this.createForm.infographic = null;
      this.createForm.text = '';
      this.createForm.data = null;
      this.createForm.image = null;
      this.createForm.sowhat = '';
      this.createForm.targets = [];
      this.createForm.taxonomies = [];

      if(this.type == 'text' || this.type == 'sowhat') {
        this.createForm[this.type] = '';
      }
    }
  },
  watch: {
    paragraphObjectType: function(newType, oldType) {
      if(newType != oldType) {
        if(
          this.uploadedFileUrl != null ||
          this.createForm.infographic != null ||
          this.createForm.text != '' ||
          this.createForm.data != null ||
          this.createForm.image != null ||
          this.createForm.sowhat != ''
        ) {
          this.disableChange = true;
          this.alert.show = 4;
          this.alert.type = 'danger';
          this.alert.content = 'Changes not saved. Select Cancel or Save';
        } else {
          this.type = this.paragraphObjectType;
          this.resetForm();
        }
      }
    }
  }
}
</script>

<style lang="scss">
.paragraph-object {

  // &__tt {

  // }

  &__tt-title {
    text-transform: uppercase;
    font-size: rem(15px);
    color: #000;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }

  &__tt-add {
    border: 0;
    margin: 0;
    padding: 0;
    background: none;

    svg {
      width: rem(20px);
      height: rem(20px);
      fill: $color-genoa;
      transition: fill .3s ease;
    }

    &:focus {
      outline: none;
    }
    
    &:hover {

      svg {
        fill: $color-java;
      }
    }
  }

  &__tt-empty {
    font-size: rem(13px);
    font-family: $font-family-roboto;
    color: #000;
    margin-bottom: rem(16px);

    a {
      font-weight: 700;
      color: $color-java;
      cursor: pointer;
      transition: color .3s ease;

      &:hover {
        color: $color-genoa;
      }
    }
  }

  &__tt-list {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-bottom: rem(16px);

    li {
      margin-right: rem(8px);
      margin-bottom: rem(8px);
      padding: rem(4px) rem(8px);    
      border: 1px solid rgba(0, 0, 0, 0.2);
      display: inline-block;

      &:last-child {
        margin-right: 0;
      }

      p {
        margin-bottom: 0;
        font-size: rem(13px);
        color: $color-java;
        text-transform: uppercase;
        display: inline-block;
        margin-right: rem(8px);
      }

      button {
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        vertical-align: inherit;

        svg {
          width: rem(10px);
          height: rem(10px);
          fill: #cbcbcb;
        }
        
        &:hover {

          svg {
            fill: $color-sunset;
          }
        }

        &:focus {
          outline: none;
        }
      }
    }
  }
}

.quill-container {
  color: #000;
}

.paragraph-object {

  .ql-editor {

    h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote {
      margin-bottom: rem(16px);
    }
  }
}

// .ProseMirror {
//   outline: none;
//   color: #000;

//   h1, h2, h3 {
//     margin-bottom: rem(24px);
//   }

//   blockquote {
//     background: rgba(0, 0, 0, 0.1);
//     padding: rem(8px);

//     :last-child {
//       margin-bottom: 0;
//     }
//   }

//   li {

//     :last-child {
//       margin-bottom: 0;
//     }
//   }
// }
</style>